import { Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LegendIcon } from '../../../../../../../styles';
import { StyledIconButton } from './shared-styles';

interface DisplayLegendToggleProps {
  onClick: () => void;
}

export const DisplayLegendToggle = (props: DisplayLegendToggleProps) => {
  const { onClick } = props;
  const { t } = useTranslation();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <Tooltip
      title={t('common:commonValues.tooltips.toggleLegend')}
      placement="top"
    >
      <StyledIconButton
        onClick={handleClick}
        size="small"
        aria-label="Toggle Legend"
      >
        <LegendIcon />
      </StyledIconButton>
    </Tooltip>
  );
};
